import { Stack, Tab, Tabs, Typography } from '@mui/material'
import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { TabsStyle } from '../../../../components/ProjectPage/ProjectTabs/style'

export const EditGrowthToolTabs = ({ title }: { title: string }) => {
  const location = useLocation()
  const currentTab = location.pathname.includes('/administration')
    ? 2
    : location.pathname.includes('/images')
      ? 1
      : 0

  return (
    <Stack alignItems="center" pt={{ xs: '15px', md: '50px' }} height="100%" px={1.5}>
      <Stack gap={2} maxWidth={{ xs: '736px', md: '840px' }} width="100%" height="100%">
        <Typography variant="h1" px={{ xs: 0, md: 2.5 }}>
          {title}
        </Typography>
        <Stack direction="column" gap={{ xs: 1.5, sm: 2 }}>
          <Tabs
            value={currentTab}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={TabsStyle}
          >
            <Tab label="Описание" component={NavLink} to="" end />
            <Tab label="Изображения" component={NavLink} to="images" />
            <Tab label="Администрирование" component={NavLink} to="administration" />
          </Tabs>
          <Outlet />
        </Stack>
      </Stack>
    </Stack>
  )
}
